import { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { modalActions } from '../store/modalSlice';
import { X } from 'lucide-react';
import ModalContent from '../Components/ModalContainer';
import '../styles/modal.css';
import { LanguageContext } from "../context/language/LanguageContext";
import IconButton from './IconButton';

export default function CustomModal(props) {
    const languageContext = useContext(LanguageContext);
    const modal = useSelector(state => state.modal);
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
        dispatch(modalActions.closeModal());
    };
    const dispatch = useDispatch();

    useEffect(() => {
        setOpen(modal.isShow);
    }, [modal.isShow]);

    useEffect(() => {
        if (!open) return;

        const handleEscape = (event) => {
            if (event.key === "Escape") {
                handleClose();
            }
        };

        window.addEventListener("keydown", handleEscape);
        return () => window.removeEventListener("keydown", handleEscape);
    }, [open]);

    return (
        <div>
            {open && (
                <div
                    className="modal_overlay"
                    onMouseDown={handleClose}
                    role="presentation"
                >
                <div
                    className='modal'
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    onMouseDown={(event) => event.stopPropagation()}
                >
                    <div className='modal_title' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <IconButton
                            className="p-2"
                            data-testid="custom-modal-close"
                            onClick={() =>
                            dispatch(modalActions.closeModal())
                        }
                        >
                            <X size={20} />
                        </IconButton>
                        <h1 id="modal-modal-title">
                            {languageContext.getTranslation(props.title)}
                        </h1>
                    </div>
                    <div id="modal-modal-description" style={{ height: '90%', overflowY: 'scroll' }}>
                        <ModalContent content={props.content} />
                    </div>
                </div>
                </div>
            )}
        </div>
    );
}
